export const SEND_MAIL_TO_EMAIL = 'SEND_MAIL_TO_EMAIL';

export function sendMailToEmail(data) {
  return {
    type: SEND_MAIL_TO_EMAIL,
    payload: data,
  }
}


// WEBPACK FOOTER //
// ./src/actions/stageReady/index.js